import { Api } from 'utils';

class AssistantService {
		
	static get = async (params?: any) => Api.createResponse('client/assistants',params);
	static check = async (params?: any) => Api.createResponse('client/assistants/check',params);
	static save = async (params?: any) => Api.createResponse('client/assistants/save',params);
	static getData = async (params?: any) => Api.createResponse('client/assistants/data',params);
	static delete = async (params?: any) => Api.createResponse('client/assistants/delete',params);
	static changeStatus = async (params?: any) => Api.createResponse('client/assistants/change-status',params);
	static view = async (params?: any) => Api.createResponse('client/assistants/view',params);
	static readFile = async (params?: any) => Api.createResponse('client/assistants/read-file',params);

}

export default AssistantService;